var __jsx = React.createElement;
import React from 'react';
import { goTo } from "../../../state/utils/url";
import Page from "../../../components/base/Page";
import LoadingPage from "../../../components/common/loading";
import { RoutesPaths } from "../../../shared/constants/RoutesPaths";
var Login = function Login() {
  goTo(RoutesPaths.HOME);
  return /*#__PURE__*/React.createElement(LoadingPage, {
    loading: true
  });
};
export default Page(Login, {
  authenticated: true
});